<script>
	import { textConsent } from "../placeholderText.js";
	import { getContext } from "svelte";
	import ViewMarkdown from "../modals/ViewMarkdown.svelte";

	export let conditions;
	let studyConsent = textConsent;

	const iconOn = "&#128993;";
	const iconOff = "&#9898;";
	let iconMain = iconOn;

	const getStorage = () => {
		let params = JSON.parse(localStorage.getItem("createStudyParams"));
		if (params) {
			if (params.studyConsent) {
				studyConsent = params["studyConsent"];
			}
		} else {
			studyConsent = textConsent;
			params = { studyConsent: textConsent };
		}
		localStorage.setItem("createStudyParams", JSON.stringify(params));
	};
	getStorage();
	$: getStorage(conditions);

	const updateStorage = (parameters) => {
		let params = JSON.parse(localStorage.getItem("createStudyParams"));
		params["studyConsent"] = parameters;
		localStorage.setItem("createStudyParams", JSON.stringify(params));
	};
	$: updateStorage(studyConsent);

	const toggleText = () => {
		if (studyConsent === "") {
			studyConsent = textConsent;
			iconMain = iconOn;
		} else {
			studyConsent = "";
			iconMain = iconOff;
		}
		updateStorage(studyConsent);
	};

	// modal to render markdown
	const { open, close } = getContext("simple-modal");
	const viewMarkdown = (text) =>
		open(ViewMarkdown, { text: text, onClose: close });

	const formatForAPI = (conditions, parameters, parameterName) => {
		let paramsSelected = JSON.parse(
			localStorage.getItem("createStudyParamsSelected")
		);
		let formatted = [];
		for (let i = 0; i < conditions; i++) {
			formatted.push({
				condition: i + 1,
				param: parameterName,
				value: parameters, // duplicate for all conditions
			});
		}
		if (paramsSelected) {
			paramsSelected[parameterName] = formatted;
		} else {
			paramsSelected = {};
			paramsSelected[parameterName] = formatted;
		}
		localStorage.setItem(
			"createStudyParamsSelected",
			JSON.stringify(paramsSelected)
		);
	};
	$: formatForAPI(conditions, studyConsent, "consent");
</script>

<hr />
<h3>Informed consent</h3>
<p>
	Use <strong>Markdown</strong> if you want to format/edit the text. Click
	<a href="#" on:click|preventDefault={() => toggleText()}>
		{@html iconMain}</a
	> to toggle consent on/off.
</p>
<div>
	<label for="consent" />
	<textarea name={"consent"} rows="4" cols="50" bind:value={studyConsent} />
</div>
<button
	on:click|preventDefault={() => {
		viewMarkdown(studyConsent);
	}}>View formatted consent</button
>

<style>
	label {
		margin-bottom: 13px;
		font-size: 1.1em;
	}
	textarea {
		width: 89%;
		height: 89px;
	}
</style>
